import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const LeftListIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33398 4.16602H14.0007"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.6 11.7611C4.31111 12.2374 4.66667 12.4755 4.66667 12.8327C4.66667 13.1899 4.31111 13.428 3.6 13.9043C2.88889 14.3806 2.53333 14.6186 2.26667 14.4401C2 14.2615 2 13.7852 2 12.8327C2 11.8802 2 11.4039 2.26667 11.2253C2.53333 11.0468 2.88889 11.2848 3.6 11.7611Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.6 3.09509C4.31111 3.57135 4.66667 3.80947 4.66667 4.16667C4.66667 4.52386 4.31111 4.76199 3.6 5.23825C2.88889 5.71451 2.53333 5.95263 2.26667 5.77403C2 5.59544 2 5.11918 2 4.16667C2 3.21415 2 2.73789 2.26667 2.5593C2.53333 2.3807 2.88889 2.61883 3.6 3.09509Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.33398 8.5H14.0007"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.33398 12.834H14.0007"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
